<template>
  <common-dialog ref="dialog" :title="title" width="1000px" @closed="onClosed">
    <el-table size="mini" :data="data" stripe border>
      <el-table-column prop="StudentNumber" label="学号" />
      <el-table-column prop="FullName" label="学生姓名" />
      <el-table-column prop="ClassName" label="班级" min-width="120" />
      <el-table-column prop="LeaveType" label="请假类型" />
      <el-table-column prop="StartDate" label="请假开始日期" min-width="120">
        <template slot-scope="{row}">
          <span>{{$commonJs.toDateString(row.StartDate)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="StartSectionName" label="开始节次"></el-table-column>
      <el-table-column prop="EndDate" label="请假结束日期" min-width="120">
        <template slot-scope="{row}">
          <span>{{$commonJs.toDateString(row.EndDate)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="EndSectionName" label="结束节次"></el-table-column>
    </el-table>
    <template slot="footer">
      <el-button size="mini" type="primary" @click="onExport">导 出</el-button>
      <el-button size="mini" @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import detailsDialogMixin from "@/mixins/detailsDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [detailsDialogMixin],
  components: { commonDialog },
  data() {
    return {
      api: require("@/api/st/leave").default,
      data: [],
      params: {},
      title: "导出 请假信息",
    };
  },
  methods: {
    getData(params) {
      this.params = this.$commonJs.obj.removeNullKey(params);
      this.$refs.dialog.isLoading = true;
      this.api.list(this.params).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) this.data = res.Data;
      });
    },
    onExport() {
      this.api.export(this.params);
    },
    onClosed() {
      this.data = [];
      this.params = {};
    },
  },
};
</script>